import { SuperAdminNotification } from "types/working-model";
import SuperAdminNoticationRow from "./super-admin-notification-row";

interface Props {
	superAdminNotifications: SuperAdminNotification[]
}
export default function SuperAdminNotifications({ superAdminNotifications }: Props) {
	if (!superAdminNotifications.length) {
		return <div className="no-notifications">No updates</div>;
	}

	return (
		<div className="super-admin-notifications">
			{superAdminNotifications.map((notification, idx) => (
				<SuperAdminNoticationRow
					notification={notification}
					key={idx}
				/>
			))}
		</div>
	);
}